/*
 * inventory-limit-v6.js – Empire vintage + PageFly + GS-Inventory
 */

(function () {

  /* ---------- SKU → minimum table ---------- */
  function minFromSku(s=''){ s=s.toLowerCase();
    if(s.startsWith('2_'))  return 7;
    if(s.startsWith('3_'))  return 7;
    if(s.startsWith('4_'))  return 5;
    if(s.startsWith('6_'))  return 3;
    if(s.startsWith('8_'))  return 1;
    if(s.startsWith('9_'))  return 1;
    if(s.startsWith('10_')) return 1;
    if(s.startsWith('air_'))return 5;
    if(s.startsWith('aqua_'))return 5;
    return 1;
  }
  window.getMinQtyFromSku = minFromSku;

  document.addEventListener('DOMContentLoaded', () => {

    const block = document.querySelector('script[type="application/json"][data-section-type="static-product"]')
               || document.querySelector('script[type="application/json"][data-product-json]');
    if(!block) return;
    const product = JSON.parse(block.textContent).product || JSON.parse(block.textContent);
    if(!product?.variants) return;

    /* inventory from GS-Inventory object */
    function getInv(id){
      if(window.gsInventoryQty && window.gsInventoryQty[id] !== undefined){
        const raw = window.gsInventoryQty[id];
        return Number.isFinite(raw) ? raw : 0;   // 'na' → 0
      }
      return null;                               // unknown
    }

    const btns = scope =>
      Array.from(scope.querySelectorAll('.product-form--atc-button,[data-product-atc]'));

    const variantById = id =>
      product.variants.find(v => v.id === Number(id));

    async function paint(btn, v){
      if(!v) return;
      let qty = getInv(v.id);
      if(qty == null) qty = v.available ? 9999 : 0;     // fallback
      const min  = minFromSku(v.sku);
      const base = btn.dataset.defaultLabel || btn.textContent.trim() || 'Add to cart';

      if(qty < min){
        btn.disabled = true;
        btn.classList.add('disabled');
        btn.textContent = `Min ${min} – only ${qty} left`;
      }else{
        btn.disabled = false;
        btn.classList.remove('disabled');
        btn.textContent = base;
      }
    }

    function guard(form){
      if(form.__guarded) return; form.__guarded = true;
      const idInput = form.querySelector('[name="id"]'); if(!idInput) return;

      const refresh = () => {
        const v = variantById(idInput.value);
        btns(form).forEach(b => paint(b, v));
      };
      refresh();

      form.addEventListener('change', refresh);
      new MutationObserver(refresh).observe(idInput,{attributes:true,attributeFilter:['value']});
    }

    document.querySelectorAll('form[action="/cart/add"]').forEach(guard);
    new MutationObserver(m => m.forEach(r => r.addedNodes.forEach(n=>{
      if(n.nodeType===1 && n.matches('form[action="/cart/add"]')) guard(n);
    }))).observe(document.body,{childList:true,subtree:true});

    document.addEventListener('click', e => {
      const b = e.target.closest('.product-form--atc-button,[data-product-atc]');
      if(b && b.disabled){ e.preventDefault(); e.stopPropagation(); }
    }, true);

    console.info('ATC-guard loaded ✓');
  });
})();